import React from "react";
import { currentSelectedModifier, distingModifierType, getModifierGroup } from "../../../helpers/combo/kidsCombo/kidsComboHelper";
import * as CONSTANT from "../../../constants";
import { Col } from "react-bootstrap";
import SelectCard from "../../Molecules/Card/SelectCard/SelectCard";
import { verifyStatus } from "../../../helpers/customizedItem/customizedItem.helper";
import CounterCard from "../../Molecules/Card/CounterCard/CounterCard";
import { IKidsComboModifierItem, IModifierGroups } from "../../../models/kidsCombo";
import styleClasses from "./kidsCombo.module.scss";
interface INestedModifiersViewProps {
  modifier: IKidsComboModifierItem;
  selectedItemId: string;
  modifierGroup: IKidsComboModifierItem;
  modifierGroupsQueue: IModifierGroups[];
  handleIngredientSelection: () => void;
  pushToItemStack: (item: IKidsComboModifierItem, type: string, isFirstSelection?: boolean) => void;
  nestedParentId?: number;
  orderType: string;
}

const NestedModifiersView: React.FC<INestedModifiersViewProps> = (props) => {
  const {
    modifier,
    selectedItemId,
    modifierGroup,
    modifierGroupsQueue,
    handleIngredientSelection,
    pushToItemStack,
    nestedParentId,
    orderType,
  } = props

  const selected = currentSelectedModifier(
    modifier,
    selectedItemId,
    modifierGroup?.type
  );

  return (
    <>
      <Col xs="4" md="3" className={`py-md-3 ${styleClasses.select_card_mobile_view}`} key={modifier?.id}>
        {modifierGroup?.type === CONSTANT.ADD_ONS ||
        modifierGroup?.type === CONSTANT.COMPLIMENTARY_MODIFIER ? (
          <CounterCard
            id={modifier.id}
            brink_id={modifier.brink_modifier_id}
            image={`${CONSTANT.REACT_APP_CLOUD_FRONT}${modifier.image}`}
            title={modifier.name}
            default_selected={modifier.is_selected}
            calories={modifier.calories}
            price={modifier.price}
            is_active={verifyStatus(modifier, CONSTANT.MODIFIER_LOCATION) && (modifier?.is_delivery || orderType !== CONSTANT.DELIVERY_ORDER_TYPE)}
            handleClick={(data) => {
              distingModifierType(
                data,
                modifierGroup,
                handleIngredientSelection
              );
            }}
            max={modifier.max}
            count={selected?.quantity || 0}
            additionalPrice={selected?.additionalPrice}
            priceAlternateLabel={selected ? "Included" : "include"}
            nestedParentId={nestedParentId}
            from={CONSTANT.TRY_2_COMBO}
            counterMob={styleClasses.counter_mob}
          />
        ) : (
          <SelectCard
            id={modifier?.id}
            brink_id={modifier?.brink_modifier_id}
            image={`${CONSTANT.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
            title={modifier.name}
            price={modifier.price}
            calories={modifier.calories}
            groupMin={modifier?.modifier_group_min}
            is_active={verifyStatus(modifier, CONSTANT.MODIFIER_LOCATION) && (modifier?.is_delivery || orderType !== CONSTANT.DELIVERY_ORDER_TYPE)}
            priceAlternateLabel={selected ? " " : " "}
            handleClick={(data) => {
              if (
                Object.keys(getModifierGroup(modifier, modifierGroupsQueue))
                  ?.length
              )
                pushToItemStack(modifier, modifierGroup?.type);
              distingModifierType(
                data,
                modifierGroup,
                handleIngredientSelection
              );
            }}
            selected={Boolean(selected)}
            default_selected={false}
            modifierAdditionalPrice={selected?.additionalPrice}
            extendableLimitValue={selected ? 2 : 1}
            nestedParentId={nestedParentId}
          />
        )}
      </Col>
    </>
  );
};

export default NestedModifiersView;
